import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo } from 'react'
import { Reception4 } from 'react-bootstrap-icons'
import { SharedCampaignContext } from '../../../../../../contexts/Advertiser/SharedCampaignContext'
import { currencyFormat, separateThousands } from '../../../../../../utils/Helper'

export default observer(function TotalSocialSection({ influencer, campaignScenario }) {
  const { campaign } = useContext(SharedCampaignContext)

  const actions = useMemo(() => campaignScenario.actions.filter(action => action.influencer_id === influencer.id), [campaignScenario.actions, campaignScenario.actions.length])

  const advertiserPrice = useMemo(() => actions.reduce((result, action) => result + action.totalAdvertiserPrice, 0))
  const totalImpression = useMemo(() => actions.reduce((result, action) => result + action.impression, 0))
  const grossReach = useMemo(() => actions.reduce((result, action) => result + action.reach, 0), [actions, actions.length])
  const buyoutPrice = useMemo(() => actions.reduce((result, action) => result + action.buyoutPrice, 0))

  return (
    <div className="grid grid-cols-8 border-t-2 border-border-primary dark:border-rb-dark-mode-lighter">
      <div className="flex items-center col-span-2 border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2 col-span-4">
        <Reception4 className="text-white bg-gray-950" style={{ padding: 2 }} />
        <p className="ml-2 font-bold dark:text-white">Total Social</p>
      </div>
      <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
        <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Total Impression.</p>
        <p className="font-bold text-sm dark:text-white">{separateThousands(totalImpression)}</p>
      </div>
      <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
        <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Gross Reach</p>
        <p className="font-bold text-sm dark:text-white">{separateThousands(grossReach)}</p>
      </div>
      <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
        <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Price</p>
        <p className="font-bold text-sm dark:text-white">{currencyFormat(advertiserPrice.toFixed(2), campaign.currency_symbol)}</p>
      </div>
      <div className="p-2">
        <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Buyouts</p>
        <p className="font-bold text-sm dark:text-white">{currencyFormat(buyoutPrice.toFixed(2), campaign.currency_symbol)}</p>
      </div>
    </div>
  )
})